<div class="cover" #cover></div>
<div class="loading-content" #popupElement>
  <cs-spinner></cs-spinner>
  @if (getMessage()) {
    <cs-label>{{getMessage()}}</cs-label>
  }
</div>